export enum PbxStatus {
    ACTIVE = "Активный",
    DISABLED = "Отключенный"
}
